import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  backgroundColor: 'gray' | 'white';
  children: ReactNode;
  className?: string;
  hasPadding: boolean;
  hidden: boolean;
}

export const DeviceViewContentEntityBackground: FC<Props> = (props) => (
  <div
    className={classNames(
      props.hidden ? 'hidden' : 'flex flex-1 flex-col',
      props.backgroundColor === 'white' && 'bg-white',
      props.hasPadding && 'p-2',
      props.className,
    )}
  >
    {props.children}
  </div>
);
